import urlParser from 'js-video-url-parser';

export const parseEmbedUrl = (url: string): string | null => {
  if (!url) return null;

  const ob = urlParser.parse(url);
  if (!ob) return null;

  const embed = urlParser.create({
    videoInfo: ob,
    format: 'embed',
  });
  if (!embed) return null;

  return embed;
};
